import React, { useEffect, useState } from 'react';
import './Vehicles.css'
import Sidebar from '../Components/Layout/Sidebar';
import { Header } from '../Components/Layout/Header';
import PageTitle from '../Components/Common/PageTitle';
import StatCard from '../Components/Common/StatCard';

import Ev from '../Assets/Icons/Ev.svg'
import Show from '../Assets/Icons/Show.svg'
import Charge from '../Assets/Icons/Charge.svg'
import CarCard from '../Components/Common/CarCard';

import { supabase } from '../supabase';
import Btn from '../Components/Common/Btn';

const Vehicles = () => {
    
    const [cars, setCars] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [editingCar, setEditingCar] = useState(null);

    const [carName, setCarName] = useState('');
    const [range, setRange] = useState('');
    const [hp, setHp] = useState('');
    const [topSpeed, setTopSpeed] = useState('');
    const [imageFile, setImageFile] = useState(null);

     const getCars = async () => {
            const res = await supabase.from("fleet").select('*');
            setCars(res.data)
        }

    useEffect(() => {
        getCars();
    } , [])

    const handleDeleteCar = async (id) => {
        const { res } = await supabase
            .from('fleet')
            .delete()
            .eq('id', id);
    };

    const handleOpenCreateModal = () => {
        setEditingCar(null);
        setCarName('');
        setRange('');
        setHp('');
        setTopSpeed('');
        setImageFile(null);
        setIsModalOpen(true);
    };

    const handleOpenEditModal = (car) => {
        setEditingCar(car); 
        setCarName(car.car_name);
        setRange(car.range);
        setHp(car.hp);
        setTopSpeed(car.top_speed);
        setImageFile(null); 
        setIsModalOpen(true);
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setUploading(true);

        try {
            let publicImageUrl = editingCar ? editingCar.car_img : ''; // Default to old image if editing

            // If a new image file was explicitly selected, upload it
            if (imageFile) {
                const fileExt = imageFile.name.split('.').pop();
                const fileName = `${Math.random()}.${fileExt}`;
                const filePath = `${fileName}`;

                const { error: uploadError } = await supabase.storage
                    .from('Evs_Imgs')
                    .upload(filePath, imageFile);

                if (uploadError) throw uploadError;

                const urlResponse = supabase.storage.from('Evs_Imgs').getPublicUrl(filePath);
                publicImageUrl = urlResponse.data?.publicUrl || urlResponse.publicUrl || '';
            }

            const payload = {
                car_name: carName,
                range: range,
                hp: hp,
                top_speed: topSpeed,
                car_img: publicImageUrl
            };

            if (editingCar) {
                // ---- EDIT MODE ----
                const { error: updateError } = await supabase
                    .from('fleet')
                    .update(payload)
                    .eq('id', editingCar.id); // Update only this specific car row

                if (updateError) throw updateError;
            } else {
                // ---- CREATE MODE ----
                const { error: insertError } = await supabase
                    .from('fleet')
                    .insert([payload]);

                if (insertError) throw insertError;
            }

            // Reset and clean up UI state
            setCarName('');
            setRange('');
            setHp('');
            setTopSpeed('');
            setImageFile(null);
            setEditingCar(null);
            setIsModalOpen(false);
            getCars(); // Refresh grid layout

        } catch (error) {
            console.error('Transaction Failed:', error);
            alert(`Error executing transaction: ${error.message || error}`);
        } finally {
            setUploading(false);
        }
    };

    return ( 
        <main className='Vehicles'>
            <Sidebar />

            <div className='MainContent'>
                <Header />

                <div className='PageCards'>
                    <div className='PageHeader'>
                        <PageTitle TitleText='Fleet Overview' SubText='Managing high-performance electric vehicles for the 2024 Electrify Egypt event with real-time status monitoring for showroom displays' HeaderBtnsClass='NoHeaderBtns'/>
                        <Btn BtnStyle='AddBtn' BtnText='Register Vehicle' onClick={handleOpenCreateModal}/>
                    </div>

                    <section className='StatCards'>
                        <StatCard SCardLabel="TOTAL FLEET" SCardValue={cars.length} SCardIcon={Ev}/>
                        <StatCard SCardLabel="ACTIVE SHOWROOMS" SCardValue='2' SCardIcon={Show}/>
                        <StatCard SCardLabel="CURRENT CHARGING" SCardValue={cars.length} SCardIcon={Charge}/>
                    </section>

                    <section className='CarCards'>
                        {
                            cars.map((item) => (
                                <CarCard CarImg={item.car_img} CarName={item.car_name} CarId={item.car_id} CarRange={item.range} CarHp={item.hp} CarSpeed={item.top_speed} deleteFunc={()=>{handleDeleteCar(item.id)}} editFunc={()=> handleOpenEditModal(item)}/>
                            ))
                        }
                    </section>
                </div>
            </div>


            {/* adding cars */}

            {isModalOpen && (
                <div className="ModalOverlay">
                    <div className="ModalCard">
                        <div className="ModalHeader">
                            <h2>{editingCar ? 'Edit Vehicle Specifications' : 'Deploy New Vehicle Asset'}</h2>
                            <button className="CloseBtn" onClick={() => setIsModalOpen(false)}>×</button>
                        </div>
                        <form onSubmit={handleFormSubmit}>
                            <div className="FieldGroup">
                                <label>VEHICLE MODEL NAME</label>
                                <input 
                                    type="text" 
                                    required 
                                    placeholder="e.g. Porsche Taycan Turbo S"
                                    value={carName}
                                    onChange={(e) => setCarName(e.target.value)}
                                />
                            </div>
                            <div className="FieldGroup">
                                <label>BATTERY RANGE</label>
                                <input 
                                    type="text" 
                                    required 
                                    placeholder="e.g. 550 KM" 
                                    value={range}
                                    onChange={(e) => setRange(e.target.value)}
                                />
                            </div>
                            <div className="FieldGroup">
                                <label>HORSEPOWER</label>
                                <input 
                                    type="text" 
                                    required 
                                    placeholder="e.g. 750 HP" 
                                    value={hp}
                                    onChange={(e) => setHp(e.target.value)}
                                />
                            </div>
                            <div className="FieldGroup">
                                <label>TOP SPEED</label>
                                <input 
                                    type="text" 
                                    required 
                                    placeholder="e.g. 260 KM/H" 
                                    value={topSpeed}
                                    onChange={(e) => setTopSpeed(e.target.value)}
                                />
                            </div>
                            <div className="FieldGroup">
                                <label>VEHICLE IMAGE</label>
                                <input 
                                    type="file" 
                                    accept="image/*" 
                                    required
                                    onChange={(e) => setImageFile(e.target.files[0])}
                                />
                            </div>
                            <button type="submit" className="SubmitVehicleBtn" disabled={uploading}>
                                {uploading ? 'Processing & Uploading...' : 'Deploy to Fleet Table'}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </main>
     );
}
 
export default Vehicles;